import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ai-other-collections',
  templateUrl: './ai-other-collections.component.html',
  styleUrls: ['./ai-other-collections.component.scss']
})
export class AIOtherCollectionsComponent implements OnInit {
  slidesData: any = [];
  exclusiveData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getOtherBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
    });

    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.exclusiveData = [];

        this.exclusiveData = singleservice.filter((data)=>{
          return !data["isExclusive"] && !data["isFeatured"] && !data["isLatest"] && !data["isPopular"] && data["isAICollection"]
        })

        //console.log(this.exclusiveData);
      }
    );
  }

}
